export default function onSmallScreen() {
  // Use outerWidth because if we are in an iframe, innerWidth returns the size
  // of the iframe, which is not helpful. `window.parent.innerWidth` doesn't
  // work when the iframe is on a different domain than the iframe.
  return window.outerWidth <= 500;
}
